"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderCheckboxDefault = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var __1 = require("../");
var styles_1 = require("./styles");
var renderCheckboxDefault = function (_a, onChange, isSelected) {
    var id = _a.id, name = _a.name, selected = _a.selected;
    return (react_1.default.createElement(styles_1.FormControlLabelAligned, { key: id, label: name, control: react_1.default.createElement(__1.Checkbox, { name: name, checked: isSelected || selected || false, onChange: onChange }) }));
};
exports.renderCheckboxDefault = renderCheckboxDefault;
function OptionsList(_a) {
    var onSelectAll = _a.onSelectAll, onSelectNone = _a.onSelectNone, onChange = _a.onChange, isSelected = _a.isSelected, options = _a.options, _b = _a.renderCheckbox, renderCheckbox = _b === void 0 ? renderCheckboxDefault : _b, error = _a.error, onErrorDismiss = _a.onErrorDismiss;
    var t = (0, react_i18next_1.useTranslation)().t;
    var showSelectAllButtons = !!onSelectAll && !!onSelectNone;
    return (react_1.default.createElement(styles_1.Container, null,
        showSelectAllButtons && (react_1.default.createElement(styles_1.ActionsContainer, null,
            react_1.default.createElement(__1.Button, { variant: "text", onClick: onSelectAll }, t('prism-header:select-all', 'Select all')),
            react_1.default.createElement(__1.Button, { variant: "text", onClick: onSelectNone }, t('prism-header:clear-selections', 'Clear selections')))),
        error && (react_1.default.createElement(__1.Alert, { severity: "error", onClose: onErrorDismiss }, error)),
        react_1.default.createElement(styles_1.FormGroupColumns, { options: options }, options === null || options === void 0 ? void 0 : options.map(function (option) {
            return renderCheckbox(option, onChange, isSelected === null || isSelected === void 0 ? void 0 : isSelected(option));
        }))));
}
exports.default = OptionsList;
//# sourceMappingURL=index.js.map